// eslint-disable-next-line no-unused-vars
import { hoverTooltip } from '@codemirror/view';

import './hoverTooltip.scss';

/**
 *
 * @param {import('@knitiv/api-client-javascript').AlgoGetInfoOutput['result']} infos
 * @param {import('angular').translate.ITranslateService} translate
 * @returns {any}
 */
export const wordHover = (infos, translate) => hoverTooltip((view, pos, side) => {
	const line = view.state.doc.lineAt(pos);
	const { from, to, text } = line;
	let start = pos;
	let end = pos;
	while (start > from && /\w/.test(text[start - from - 1])) {
		start--;
	}
	while (end < to && /\w/.test(text[end - from])) {
		end++;
	}
	if ((start === pos && side < 0) || (end === pos && side > 0)) {
		return null;
	}

	const match = text.slice(start - from, end - from);

	if (!(match in infos.functions)) {
		return null;
	}

	const value = infos.functions[match];
	const element = typeof value === 'string'
		? infos.functions[value.slice(1)]
		: value;

	// if an alias point to an alias, error
	if (typeof element === 'string') {
		return null;
	}

	const desc = translate.instant(element.description) ?? '<i>Pas de description</i>';
	const name = match;
	const parametersLong = element.params.map(parameter => `
${parameter.name}: ${parameter.type ?? 'any'} - `
+ `${translate.instant(parameter.description) ?? '<i>Pas de description</i>'}
`).join('<br>');
	const parametersShort = element.params
		.map(parameter => `${(parameter.variadic ? '...' : '') + parameter.name}: ${parameter.type ?? 'any'}`)
		.join(', ');

	return {
		pos: start,
		end,
		arrow: true,
		above: true,
		create() {
			const dom = document.createElement('div');
			dom.classList.add('fn-tooltip');
			dom.innerHTML = `${name}(${parametersShort}): `
			+ `${element.type ?? 'any'}<br><br>${desc}<br><br>Parametres:<br>${parametersLong}`;
			return {
				dom,
			};
		},
	};
});
